import * as CONSTANTS_SERVICE from './index'
import CustomColumn from './customColumn'
import LsKey from './lsKey'

const CONSTANTS = { ...CONSTANTS_SERVICE, CustomColumn, LsKey }

export default CONSTANTS
